import { render, staticRenderFns } from "./DialogPushCard.vue?vue&type=template&id=42e1d392&scoped=true&"
import script from "./DialogPushCard.vue?vue&type=script&lang=js&"
export * from "./DialogPushCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e1d392",
  null
  
)

export default component.exports